import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../text/messages';
import { LOADING, SAVING, SET_PROGRESS, COMPLETE } from './types';

const defaultState = {
    loading: false,
    message: undefined,
    progress: undefined,
    count: 0
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case LOADING:
            return { ...state, loading: true, message: undefined, count: state.count + 1 };

        case SAVING:
            return { ...state, loading: true, message: <FormattedMessage {...messages.saving} />, count: state.count + 1 };

        case COMPLETE:
            return { ...state, loading: false, message: undefined, progress: undefined, count: state.count - 1 };

        case SET_PROGRESS:
            return { ...state, message: undefined, progress: action.data };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/loader.jsx